import TapAndPlayIcon from "@mui/icons-material/TapAndPlay";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { Box, Chip, Stack } from "@mui/material";
import { LICENSE_CODE_TO_PERKS_MAP } from "Components/Licenses/licenseUtils";
import type { LicenseCode } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.LicensePicker.Perks;

const CHIP_SX = {
  p: 3.5,
  fontSize: "0.875rem",
};

type PerksProps = {
  licenseType: LicenseCode;
};

export const Perks = ({ licenseType }: PerksProps) => {
  const { t } = useResource();
  const { terminals, subAccounts } = LICENSE_CODE_TO_PERKS_MAP[licenseType];
  const hasSubAccounts = subAccounts > 0;

  return (
    <Box display="flex" justifyContent="center" flexWrap="wrap" gap={2}>
      <Chip
        variant="outlined"
        size="small"
        icon={<TapAndPlayIcon />}
        label={
          <Stack direction="row" gap={1} ml={1}>
            <strong>{terminals}</strong>
            {t(RESOURCES.Terminals, { count: terminals })}
          </Stack>
        }
        sx={CHIP_SX}
      />
      <Chip
        variant="outlined"
        size="small"
        icon={<PeopleAltOutlinedIcon />}
        label={
          hasSubAccounts ? (
            <Stack direction="row" gap={1} ml={1}>
              <strong>{subAccounts}</strong>
              {t(RESOURCES.SubAccounts, { count: subAccounts })}
            </Stack>
          ) : (
            t(RESOURCES.NoSubAccounts)
          )
        }
        sx={[CHIP_SX, !hasSubAccounts && { opacity: 0.45 }]}
      />
    </Box>
  );
};
